import { useEffect, useState } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, MsalProvider } from '@azure/msal-react';
import { msalInstance, loginRequest } from './auth/msalConfig';
import Dashboard from './pages/dashboard';
import { Route, Routes, Navigate } from 'react-router-dom';
import { Toaster } from "react-hot-toast";
import CustomerTransaction from './pages/customerTransactions';
import AppSystemTrackPage from './components/AppSystemTrackPage';

const WrappedView = () => {
  const { instance, accounts } = useMsal();
  const [isInitialized, setIsInitialized] = useState(false);
  const [redirectInProgress, setRedirectInProgress] = useState(false);

  useEffect(() => {
    // Initialize MSAL instance
    const initializeMsal = async () => {
      try {
        const response = await instance.handleRedirectPromise();
        if (response) {
          console.log("Successfully signed in:", response);
        }
      } catch (error) {
        console.error("Error during redirect processing:", error);
      } finally {
        setIsInitialized(true);
      }
    };

    initializeMsal();
  }, [instance]);

  useEffect(() => {
    if (isInitialized && accounts.length === 0 && !redirectInProgress) {
      setRedirectInProgress(true);
      instance.loginRedirect(loginRequest).catch((error) => {
        console.error("Login failed:", error);
        Toaster.error("Login failed. Please try again.");
        setRedirectInProgress(false);
      });
    }
  }, [isInitialized, accounts, instance, redirectInProgress]);

  if (!isInitialized) {
    return <p>Loading...</p>;
  }

  return (
    <div className="App">

      <div className="container">
        <div className="topBar">
          <div className='loggedAs'>
            {accounts.length > 0 ? accounts[0].name : 'Guest'}
          </div>

          <a href="/" className="navbar-item">
            <img src="https://craneww-assets.azureedge.net/assets-v2/crane-logo.svg" alt="Crane Logo" />
          </a>
        </div>

        {accounts.length > 0 ? (
          <AuthenticatedTemplate>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/transactions/status" element={<CustomerTransaction />} />
              <Route path="/transactions/app-system-track" element={<AppSystemTrackPage />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </AuthenticatedTemplate>
        ) : (
          <UnauthenticatedTemplate>
            <p>Redirecting to login...</p>
          </UnauthenticatedTemplate>
        )}

        <Toaster />
      </div>
    </div>
  );
};

const App = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <WrappedView />
    </MsalProvider>
  );
};

export default App;
